import * as React from 'react';

import { AvatarImages } from 'constants/AvatarConstants';
import Avatar, { AvatarSize } from 'components/Avatar';

type Props = {
  size?: AvatarSize;
  className?: string;
};

export default function OrgAvatar(props: Props) {
  const { size, className } = props;

  return <Avatar size={size} className={className} image={AvatarImages.ORG_AVATAR} />;
}
